import React from 'react';
import {CognitoUser} from "amazon-cognito-identity-js";

const AuthContext = React.createContext<{ user?: CognitoUser; isLoaded: boolean, updateCurrentUser: (user?: CognitoUser) => void }>({
  user: undefined,
  isLoaded: false,
  updateCurrentUser: () => {}
});
export default AuthContext;